<mat-card class="mb-3" id="customer-styling">
  <mat-card-header>
    <mat-card-title>Styling</mat-card-title>
  </mat-card-header>
  <mat-card-content fxLayout="column">
    <br>
      @if (!loadingTheme) {
        <div fxFlex fxLayout="row wrap" fxLayoutGap="2rem grid">
          <app-color-selection fxFlex="100"
            [colorSelection]="colorSelection"
          ></app-color-selection>
          <app-font-selection [fontSelection]="fontSelection"
            [currentBodyFont]="currentBodyFont"
            [currentHeaderFont]="currentHeaderFont"
            [currentButtonFont]="currentButtonFont"
            fxFlex="100"
          (onPickFont)="pickFont($event.type, $event.f)"></app-font-selection>
        </div>
      }

    </mat-card-content>
    <mat-card-actions>
      @if (!(loading$ | async)) {
        <button mat-stroked-button (click)="resetStyling()"
          matTooltip="Sætter stylingen til Grant default styling" matTooltipPosition="above"
        class="mr-3">Reset styling</button>
      }
      @if (!(loading$ | async)) {
        <button mat-flat-button color="primary" (click)="updateTheme()">Tilføj styling</button>
      }
    </mat-card-actions>
    @if (loading$ | async) {
      <mat-progress-spinner
        [diameter]="24"
        mode="indeterminate"
        color="primary"
      ></mat-progress-spinner>
    }

  </mat-card>
